import PropTypes from "prop-types";
import { AnimatePresence, motion } from "framer-motion";
import { pageTransition, pageVariants } from "../../pages/NewLogin/Animation";

/* Shared enter/exit animation wrapper for the NewLogin auth screens.
 * Extracted so LoginPage / ForgotPasswordPage / EmailSentPage don't repeat the
 * same AnimatePresence + motion.div block (SonarQube duplication). */
const AuthTransition = ({ children, style }) => (
  <AnimatePresence mode="wait">
    <motion.div
      key="login"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={style}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  </AnimatePresence>
);

AuthTransition.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};

export default AuthTransition;
